module.exports = __webpack_public_path__ + "assets/money-dollar.94369acb.svg";